"use strict";
/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
var KPI_PLACEHOLDER_MEASURE = 'placeHolderMeasure';

var MeasureDataItem =
/** @class */
function () {
  function MeasureDataItem(spec) {
    if (spec === void 0) {
      spec = {};
    }

    this.dataItemId = spec['dataItemId'];
    this.label = spec['label'];
  }

  MeasureDataItem.prototype.getDataItemId = function () {
    return this.dataItemId;
  };

  MeasureDataItem.prototype.getLabel = function () {
    return this.label;
  };

  MeasureDataItem.getPlaceHolderMeaureColumnId = function () {
    return KPI_PLACEHOLDER_MEASURE;
  };

  MeasureDataItem.getPlaceHolderMeasureDataItem = function () {
    return new MeasureDataItem({
      dataItemId: KPI_PLACEHOLDER_MEASURE,
      label: KPI_PLACEHOLDER_MEASURE
    });
  };

  return MeasureDataItem;
}();

exports.default = MeasureDataItem;
